(function() {
  var ns = window.nspace("ccc.viz.util");

  ns.Fips = {
    NYC: "3651000"
  };
})();
